import { Button } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { RootState } from "redux/store"
import { IRtiIntervention } from "types"

interface IProps {
  student: string
  intervention: IRtiIntervention
  onEditClick: any
}

const BenchmarkStudentIntervention: FC<IProps> = ({student, intervention, onEditClick}) => {
  const { t } = useTranslation()

  const user = useSelector((state: RootState) => state['user'].user)
  if(!intervention) {
    return null
  }

  return (
    <>
        <div className="info-row" style={{ fontSize: '18px' }}>
            <div className="info-box">
                <div className="info-box-title">{t('rti.intervention-plan')}</div>
                <div className="info-box-content" style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                    <div>{t('common.rti-tier')}: <b>{intervention.tier}</b></div>
                    <div>{t('rti.intervention-type')}: <b>{intervention.intervention_type?.title}</b></div>
                    <div>{t('rti.reason-for-intervention')}: <b>{intervention.need_for_support}</b></div>
                    <div>{t('rti.student-strengths')}: <b>{intervention.student_strengths}</b></div>
                    <div>{t('rti.student-weaknesses')}: <b>{intervention.student_weaknesses}</b></div>
                </div>
            </div>
            <div className="info-box">
                <div className="info-box-title">{t('rti.schedule-intervention')}</div>
                <div className="info-box-content" style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                    <div>{t('common.start-date')}: <b>{intervention.start_date}</b></div>
                    <div>{t('common.end-date')}: <b>{intervention.end_date}</b></div>
                    <div>{t('rti.monitoring-times-a-week')}: <b>{intervention.monitoring_times_a_week == 4 ? t('common.weekly') : t('common.monthly')}</b></div>
                    <div>{t('common.duration-minutes')}: <b>{intervention.evaluation_duration_minutes}</b></div>
                    <div>{t('rti.group-size')}: <b>{intervention.group_size}</b></div>
                </div>
            </div>
        </div>

        {intervention.rti_error_codes?.length > 0 && <div className="info-row" style={{ fontSize: '18px' }}>
                <div className="info-box">
                    <div className="info-box-title">{t('common.error-codes')}</div>
                    <div className="info-box-content">
                       <b>{intervention.rti_error_codes.map(e => e.title.split(":")[0]).join(", ")}</b> 
                    </div>
                </div>
            </div>}

        <div className="info-row" style={{ fontSize: '18px' }}>
            <div className="info-box">
                <div className="info-box-title">{t('rti.progress-monitoring')}</div>
                <div className="info-box-content">
                    <div><b>{t('common.progress-monitoring-tools')}</b></div>
                    <div>
                        { intervention.progress_monitoring_tools?.map((a: any, idx) => <span key={a.id}>{idx > 0 && <>, </>}{a.title}</span>) }
                    </div>

                    <div style={{ marginTop: 5 }}><b>{t('common.monitoring-methods')}</b></div>
                    <div>
                        { intervention.monitoring_methods?.map((a: any, idx) => <span key={a.id}>{idx > 0 && <>, </>}{a.title}</span>) }
                    </div>

                    <div style={{ marginTop: 5 }}><b>{t('rti.progress-rubric')}</b></div>
                    <div>
                        { intervention.progress_rubric?.title }
                    </div>
                </div>
            </div>
            <div className="info-box">
                <div className="info-box-title">{t('common.accommodations-and-modifications')}</div>
                <div className="info-box-content">
                    <div><b>{t('common.accommodations')}</b></div>
                    <div>
                        { intervention.accommodations?.map((a: any, idx) => <span key={a.id}>{idx > 0 && <>, </>}{a.title}</span>) }
                    </div>

                    <div style={{ marginTop: 10 }}><b>{t('common.modifications')}</b></div>
                    <div>
                        { intervention.modifications?.map((a: any, idx) => <span key={a.id}>{idx > 0 && <>, </>}{a.title}</span>)  }
                    </div>
                </div>
            </div>
        </div>


         <div className="info-row" style={{ fontSize: '18px' }}>
            <div className="info-box">
                <div className="info-box-title">{t('common.intervention-strategies')}</div>
                <div className="info-box-content">
                    {intervention.intervention_strategies?.map(s => <div key={s.id}>&bull; {s.title}</div>)}
                </div>
            </div>
            <div className="info-box">
                <div className="info-box-title">{t('common.instructional-strategies')}</div>
                <div className="info-box-content">
                    {intervention.instructional_strategies?.map(s => <div key={s.id}>&bull; {s.title}</div>)}
                </div>
            </div>
            <div className="info-box">
                <div className="info-box-title">{t('rti.baseline-assessment-strategies')}</div>
                <div className="info-box-content">
                    {intervention.baseline_assessment_strategies?.map(s => <div key={s.id}>&bull; {s.title}</div>)}
                </div>
            </div>
        </div>

        {onEditClick && user?.role != "parent" &&
        <div style={{ textAlign: 'right'}}>
                <Button
                  variant='contained'
                  color='white'
                  onClick={() => {
                    onEditClick()
                  }}
                >
                  {`${t('common.edit')}`}
                </Button>
        </div>}

    </>
  )
}

export default BenchmarkStudentIntervention